export default __webpack_public_path__ + "static/media/password.8f218add.svg";